export default __webpack_public_path__ + "static/media/Blooded Belt of the Far Horizon.e6e804a7.jpg";